import { useEffect, useState } from "react"

type Theme = "light" | "dark"

function readTheme(): Theme {
  if (typeof document === "undefined") return "light"
  return document.documentElement.classList.contains("dark") ? "dark" : "light"
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(readTheme)

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark")
    localStorage.setItem("theme", theme)
  }, [theme])

  const toggleTheme = () => setThemeState((t) => (t === "dark" ? "light" : "dark"))

  return { theme, setTheme: setThemeState, toggleTheme }
}
